import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  > button {
    color: #0085ff;
    border: none;
    font-weight: 700;
    padding: 0px 8px;
    border-radius: 8px;
    svg {
      margin-right: 6px;
    }
  }
`
